import { FC, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

import styles from './InfoSection.module.scss';

interface InfoSectionProps {
  icon: ReactNode;
  title: string;
  content: string;
}

const InfoSection: FC<InfoSectionProps> = ({ icon, title, content }) => {
  return (
    <Box className={styles.infoSection}>
      <Box className={styles.header}>
        <Box className={styles.iconContainer}>{icon}</Box>
        <Typography
          variant="h10Semibold"
          className={styles.title}
        >
          {title}
        </Typography>
      </Box>

      <Box className={styles.content}>
        <Typography
          variant="h10"
          className={styles.text}
        >
          {content}
        </Typography>
      </Box>
    </Box>
  );
};

export default InfoSection;
